import config from 'app-self-support-order/config'

const customerApi = `${config.apiHost}/oem-crm_third_party_shop`

export default {
    search: {
        url: `${customerApi}/api/customer/search`,
        type: 'POST',
    },
    getExternalUserIds: {
        url: `${customerApi}/api/customer/search/all`,
        type: 'POST',
    },
}
